<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M9.0625 3.90625C9.0625 4.6829 8.4329 5.3125 7.65625 5.3125C6.8796 5.3125 6.25 4.6829 6.25 3.90625C6.25 3.1296 6.8796 2.5 7.65625 2.5C8.4329 2.5 9.0625 3.1296 9.0625 3.90625Z"
            fill="currentColor"
        />
        <path
            d="M13.75 3.90625C13.75 4.6829 13.1204 5.3125 12.3438 5.3125C11.5671 5.3125 10.9375 4.6829 10.9375 3.90625C10.9375 3.1296 11.5671 2.5 12.3438 2.5C13.1204 2.5 13.75 3.1296 13.75 3.90625Z"
            fill="currentColor"
        />
        <path
            d="M9.0625 16.0938C9.0625 16.8704 8.4329 17.5 7.65625 17.5C6.8796 17.5 6.25 16.8704 6.25 16.0938C6.25 15.3171 6.8796 14.6875 7.65625 14.6875C8.4329 14.6875 9.0625 15.3171 9.0625 16.0938Z"
            fill="currentColor"
        />
        <path
            d="M13.75 16.0938C13.75 16.8704 13.1204 17.5 12.3438 17.5C11.5671 17.5 10.9375 16.8704 10.9375 16.0938C10.9375 15.3171 11.5671 14.6875 12.3438 14.6875C13.1204 14.6875 13.75 15.3171 13.75 16.0938Z"
            fill="currentColor"
        />
        <path
            d="M9.0625 10C9.0625 10.7767 8.4329 11.4062 7.65625 11.4062C6.8796 11.4062 6.25 10.7767 6.25 10C6.25 9.22335 6.8796 8.59375 7.65625 8.59375C8.4329 8.59375 9.0625 9.22335 9.0625 10Z"
            fill="currentColor"
        />
        <path
            d="M13.75 10C13.75 10.7767 13.1204 11.4062 12.3438 11.4062C11.5671 11.4062 10.9375 10.7767 10.9375 10C10.9375 9.22335 11.5671 8.59375 12.3438 8.59375C13.1204 8.59375 13.75 9.22335 13.75 10Z"
            fill="currentColor"
        />
    </svg>
</template>
